export default __webpack_public_path__ + "static/media/tr_5.cf8ff8ea.mp3";